//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import SfHeaderNavigationItem from "./_internal/SfHeaderNavigationItem.vue";
import SfHeaderNavigation from "./_internal/SfHeaderNavigation.vue";
Vue.component("SfHeaderNavigation", SfHeaderNavigation);
Vue.component("SfHeaderNavigationItem", SfHeaderNavigationItem);
import { isClient } from "../../../utilities/helpers";
import SfSearchBar from "../../molecules/SfSearchBar/SfSearchBar.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfIcon from "../../atoms/SfIcon/SfIcon.vue";
import SfTopBenefitBar from '../../molecules/SfTopBenefitBar/SfTopBenefitBar.vue';
import MoominLink from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue";
import SfOverlay from "~/themes/fiskarsMoominDefault/components/components/atoms/SfOverlay/SfOverlay.vue";
export default {
  name: "SfHeader",
  components: {
    SfSearchBar,
    SfButton,
    SfIcon,
    MoominLink,
    SfOverlay,
    SfTopBenefitBar
},
  props: {
    logo: {
      type: [String, Object],
      default: "",
    },
    logoHeight: {
      type: [Number, String],
      default: 35,
    },
    logoWidth: {
      type: [Number, String],
      default: 34,
    },
    title: {
      type: String,
      default: "",
    },
    cartIcon: {
      type: [String, Boolean, Array],
      default: "empty_cart",
    },
    wishlistIcon: {
      type: [String, Boolean, Array],
      default: "heart",
    },
    accountIcon: {
      type: [String, Boolean, Array],
      default: "profile",
    },
    activeIcon: {
      type: String,
      default: "",
      validator(value) {
        return ["", "account", "wishlist", "cart"].includes(value);
      },
    },
    searchPlaceholder: {
      type: String,
      default: "Search for items",
    },
    searchValue: {
      type: String,
      default: "",
    },
    wishlistItemsQty: {
      type: [String, Number],
      default: "0",
    },
    cartItemsQty: {
      type: [String, Number],
      default: "0",
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    isNavVisible: {
      type: Boolean,
      default: false,
    },
    isSearchOpen: {
      type: Boolean,
      default: false
    },
    benefitBarData: {
      type: Object,
    }
  },
  data() {
    return {
      icons: [],
      hidden: false,
      sticky: false,
      scrollDirection: null,
      lastScrollPosition: 0,
      animationStart: null,
      animationLong: null,
      animationDuration: 300,
    };
  },
  computed: {
    cartHasProducts() {
      return parseInt(this.cartItemsQty, 10) > 0;
    },
    benefitBarLabel() {
      return this.benefitBarData?.benefit_bar_label;
    },
    benefitBarBackground() {
      return this.benefitBarData?.benefit_bar_background?.background?.selectionValues[0]?.key;
    },
    benefitBarLink() {
      return this.benefitBarData?.benefit_bar_link;
    },
  },
  watch: {
    scrollDirection: {
      handler() {
        if (!isClient) return;
        window.cancelAnimationFrame(this.animationLong);
        this.animationLong = null;
        this.animationStart = null;
        this.animationLong = window.requestAnimationFrame(
          this.animationHandler
        );
      },
    },
    isSticky: {
      handler(isSticky) {
        if (!isClient) return;
        this.sticky = isSticky;
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.isSticky) {
      window.addEventListener("scroll", this.scrollHandler, { passive: true });
    }
  },
  beforeDestroy() {
    if (this.isSticky) {
      window.removeEventListener("scroll", this.scrollHandler, {
        passive: true,
      });
    }
  },
  methods: {
    animationHandler(timestamp) {
      if (!this.animationStart) this.animationStart = timestamp;
      const progress = timestamp - this.animationStart;
      if (progress < this.animationDuration) {
        this.animationLong = window.requestAnimationFrame(
          this.animationHandler
        );
        return;
      }
      this.hidden = this.scrollDirection === "down";
    },
    scrollHandler() {
      if (!isClient) return;
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (!!this.refs) {
        if (currentScrollPosition >= this.$refs.header.offsetHeight) {
          this.scrollDirection =
            currentScrollPosition < this.lastScrollPosition ? "up" : "down";
        }
      }
      this.lastScrollPosition = currentScrollPosition;
    },
  },
};
